import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import Body from 'ui/Typography/Body';
import Title from 'ui/Typography/Title';
import { useAppDispatch } from 'ducks/hooks';
import MountingRailInfoCard from './MountingRailInfoCard';
import { hideMountingRailSheet, isModalVisible } from './MountingRailInfo';
import SkapaButton from 'ui/Button/Button';
import styled from 'styled-components';

const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ButtonContainer = styled.div`
  margin-top: auto;
`;

const MountingRailInfoSheet = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();

  const modalVisible = useSelector(isModalVisible);

  const onDismiss = () => dispatch(hideMountingRailSheet());

  return (
    <Modal
      data-testid="mounting-rail-info-sheet"
      visible={modalVisible}
      escapable
      handleCloseBtn={onDismiss}
    >
      <Sheets
        title={formatMessage({ id: 'storageone.mountingRailInfoSheetTitle' })}
        header={
          <ModalHeader
            data-testid="modal-header"
            ariaCloseTxt={formatMessage({ id: 'storageone.closeButton' })}
          />
        }
        footer={null}
      >
        <StyledModalBody>
          <Title mb="md" type={ThemeFontStyleTypeEnum.headingMedium}>
            {formatMessage({ id: 'storageone.mountingRailInfoSheetTitle' })}
          </Title>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium} color="grey.600">
            {formatMessage({
              id: 'storageone.mountingRailInfoSheetDescription'
            })}
          </Body>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium} color="grey.600">
            {formatMessage({
              id: 'storageone.mountingRailInfoSheetWeightInfo'
            })}
          </Body>
          <MountingRailInfoCard />
          <Body type={ThemeFontStyleTypeEnum.bodySmall} color="grey.600" mb="">
            {formatMessage({
              id: 'storageone.mountingRailInfoSheetDisclaimer'
            })}
          </Body>
          <ButtonContainer>
            <SkapaButton
              type="primary"
              text={formatMessage({ id: 'storageone.boaxelMountingRailInfoSheetButtonPrimary' })}
              onClick={onDismiss}
            />
          </ButtonContainer>
        </StyledModalBody>
      </Sheets>
    </Modal>
  );
};

export default MountingRailInfoSheet;
